import { atom } from 'jotai';
import { atomWithReset } from 'jotai/utils';

import type { TeamMemberSortParams, TeamsSortParams } from '@/api/v4/team.api';
import type { IPageState } from '../../ui/table/table.types';
import type { ISort } from '../../ui/table/table.types';
import type { CompanyContact } from '@/api/v4/organization-contacts.api';

export const teamIdState = atom<string | null>(null);

export const teamContactsAtom = atomWithReset<CompanyContact[]>([]);

export const teamMembersSortState = atom<ISort<TeamMemberSortParams>>({
  sort: 'firstName',
  direction: 'desc',
});

export interface TeamFilters {
  search: string | null;
}

export const defaultAppliedTeamsFilters: TeamFilters = {
  search: null,
};

export const appliedTeamsFiltersState = atomWithReset<TeamFilters>(
  defaultAppliedTeamsFilters,
);

export const selectedTeamsFiltersState = atomWithReset<TeamFilters>(
  defaultAppliedTeamsFilters,
);

export const teamsSortState = atom<ISort<TeamsSortParams>>({
  sort: 'name',
  direction: 'desc',
});

export const defaultTeamContactsPageState = {
  page: 1,
  pageSize: 20,
};

export const teamContactsPageState = atom<IPageState>(
  defaultTeamContactsPageState,
);

export const teamContactsFormSubmitState = atom<boolean>(false);

export const editTeamContactProgressState = atom(false);

export const addTeamContactCounterState = atom(0);

export const teamContactDeletedIdState = atom<string | null>(null);
